import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService, LoadingService } from '@shared/src/public-api';
import { Observable } from 'rxjs';
import { BaseController } from '../../base.controller';

@Injectable({
    providedIn: 'root',
})
export class MesuresExtremesController extends BaseController {

    private base = '/mesuresextremes'

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        protected router: Router,
        @Inject('LoadingService') protected loadingService: LoadingService) {
        super(http, alertService, translateService, loadingService, router);
    }

    public donarBaixaTotesRutes(): Observable<boolean> {
        return this.postBusy(this.base + '/donarbaixatotesrutes', null, 'donarBaixaTotesRutes');
    }

    public recarregarHome(): Observable<boolean> {
        return this.postBusy(this.base + '/recarregarhome', null, 'recarregarHome');
    }
}
